// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { Tenant as Practice } from '@/services/practices'

export const allPracticeServicesSuccessfullyConfigured = (
  practice: Practice
): boolean => {
  for (const svc of practice.templateFragmentDeployments) {
    if (svc.status !== 'SUCCESS') {
      return false
    }
  }

  return true
}
